export default __webpack_public_path__ + "037d78a2cd9135e7d2c11d71a28f67c5.woff2";